/** @format */
import { UILoader } from '@/components/ui/Loader';
import { MapWrapper } from '@/components/ui/Map/index.style';
import { Loader as SearchLoadingLoader } from '@/components/ui/Map/Loader';
import { TTranslation } from '@/i18n/createProvider';
import { useAppTranslation } from '@/i18n/declarations';
import { API_KEY_MAPBOX } from '@/utils/gatsby/constants';
import 'mapbox-gl/dist/mapbox-gl.css';
import React, { FunctionComponent as FC, RefObject } from 'react';
import Map, {
  MapboxEvent,
  MapRef,
  NavigationControl,
  NavigationControlProps,
  ViewState,
  ViewStateChangeEvent,
} from 'react-map-gl';
import GeocoderControl from './Geocoder';

const TOKEN: string = API_KEY_MAPBOX;

const ReactMap: FC<ReactMapProps> = ({
  mapRef,
  viewport,
  setViewport,
  onMoveEnd,
  pins,
  onViewStateChange,
  scrollZoom = true,
  isSearchLoading = false,
  disableMovement = false,
  isRoomsEmpty,
  children,
  ...rest
}) => {
  const { t } = useAppTranslation();
  const [isMapLoaded, setIsMapLoaded] = React.useState(false);

  const handleMove = (e: ViewStateChangeEvent) => {
    if (disableMovement) return;
    setViewport(e.viewState);
    onViewStateChange && onViewStateChange(e);
  };

  const handleResize = (e: MapboxEvent) => {
    if (!mapRef.current) return;
    mapRef.current?.resize();
  };

  return (
    <>
      {!isMapLoaded && <UILoader />}
      <MapWrapper>
        {children}
        <Map
          {...viewport}
          ref={mapRef}
          mapStyle="mapbox://styles/dovevivo/ckqchnr66087917pmkdmnhdc0"
          onMove={handleMove}
          mapboxAccessToken={TOKEN}
          onMoveEnd={onMoveEnd}
          onLoad={e => setIsMapLoaded(e.type === 'load')}
          scrollZoom={scrollZoom}
          onResize={handleResize}
        >
          {isSearchLoading && <SearchLoadingLoader />}
          <NavigationControl
            position={rest.position ?? 'bottom-left'}
            showCompass={rest.showCompass ?? false}
            {...rest}
          />
          <GeocoderControl
            mapboxAccessToken={TOKEN}
            position="top-right"
            placeholder={t('plp.search_address' as TTranslation)}
          />

          {pins}
        </Map>
      </MapWrapper>
    </>
  );
};

export default ReactMap;

export interface ReactMapProps extends NavigationControlProps {
  zoom?: number;
  mapRef: RefObject<MapRef>;
  viewport: ViewState;
  setViewport: React.Dispatch<React.SetStateAction<ViewState>>;
  pins: JSX.Element[];
  onViewStateChange?: Function;
  scrollZoom?: boolean;
  disableMovement?: boolean;
  isSearchLoading?: boolean;
  onMoveEnd?: (e: ViewStateChangeEvent) => void;
  isRoomsEmpty: boolean;
  children?: React.ReactNode;
}
